import * as qs from "query-string-for-all";
import * as React from "react";
import axios from "axios";
// import BookVisualisation from "./BookVisualisation";
import CouncilBadge from "src/components/general/CouncilBadge";
import PeopleGrid from "src/components/general/PeopleGrid";
import { ICouncil } from "src/interfaces";
import { baseUrl } from "src/constants/ApiSettings";
import Loading from "src/components/general/Loading";
import DataMissing from "src/components/general/DataMissing";

interface IProps {
  council: ICouncil;
  ordinal: number;
  year: string;
}

interface ITrace {
  name: string;
  visits: string;
  visitsVisual: string;
}

interface IState {
  data: ITrace | null;
}

export default class LibraryVisitsTrace extends React.PureComponent<
  IProps,
  IState
> {

  public state: IState;
  constructor(props: IProps) {
    super(props);
    this.state = { 
      data: null
    };
  }

  public componentDidMount() {
    this.generateData(this.props.council, this.props.year);
  }

  public componentWillReceiveProps(newProps: IProps) {
    if (newProps.year !== this.props.year) {
      this.generateData(newProps.council, newProps.year);
    }
  }

  public generateData = (council: ICouncil, year: string) => {
    axios
      .all([
        axios.get(
          `${baseUrl}/visitsPerResident?${qs.stringify({
            council: council.id,
            year
          })}`
        )
      ])
      .then(
        axios.spread((resVisits) => {
          const visits = resVisits.data[0].value;
          
          const data: ITrace = {
            name: council.name,
            visits: (Math.round(visits * 10) / 10).toFixed(1),
            visitsVisual: (Math.round(visits * 10) / 100).toFixed(1),
          };

          this.setState({ data });
        })
      )
      // tslint:disable-next-line:no-console
      .catch(err => console.error(err));
  };

  public render() {
    const ordinal = this.props.ordinal;
    const council = this.state.data;

    if (!council) {
      return <Loading />;
    }

    return (
      <div className="w-full sm:w-1/2 mb-5">
        <div className="flex flex-row items-center">
          <CouncilBadge name={council.name} ordinal={ordinal} />
          <span className="text-white text-sm font-bold font-montserrat" style={{ maxWidth: 'calc(100% - 75px)' }}>
            {council.name}
          </span>
        </div>
        {parseFloat(council.visits) ? (
          <div className="flex flex-row items-center text-white">
            <span className="font-bold font-montserrat text-3xl ml-10 mr-3">{council.visits}</span>
            <PeopleGrid count={Number(council.visitsVisual)} />
          </div>
        ) : (
          <div className="ml-10">
            <DataMissing align="left" />
          </div>
        )}
      </div>
    );
  }
}



// WEBPACK FOOTER //
// ./src/components/report/councilExpenditure/Libraries/LibraryVisitsTrace.tsx